<template>
  <div class="nt-richtext">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'nt-richtext'
}
</script>

<style lang="scss" scoped>
  .nt-richtext {
    font-size: 1em;
    line-height: 1.4em;
    letter-spacing: -1px;
    color: $neutral-03;
    text-decoration: none;
  }
</style>
